import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { ClientService } from '../../services/client.service';
import { inject } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { catchError, map, of } from 'rxjs';
import { UtilitiesService } from '../../services/utilities.service';

function resolveClientId(route: any): string | null {
  return route.paramMap.get('clientId') ?? route.parent?.paramMap.get('clientId') ?? null;
}

function checkClientId(route: any) {
  const clientService = inject(ClientService);
  const router = inject(Router);
  const utilities = inject(UtilitiesService);

  const sorter: Sort = { active: 'fdClientId', direction: 'asc' };

  const requiredParam = resolveClientId(route);
  if (!requiredParam) {
    return of(true);
  }

  return clientService
    .getClientsGuard(1, 9999, sorter.active, sorter.direction, '', 0)
    .pipe(
      map((resData: any) => {
        utilities.setIsUniqueClient(resData.data.length === 1);

        const clientIdNum = Number(requiredParam);
        const list = resData.data ?? [];
        const exists = list.some((c: any) => c.fdClientId === clientIdNum);

        if (!exists) {
          router.navigate(['select-client']);
          return false;
        }

        const selected = list.find((c: any) => c.fdClientId === clientIdNum);
        if (selected) {
          utilities.clientId = clientIdNum; 
          utilities.setCompanyName(selected.companyName);
          utilities.setIsPartner(selected.isPartner);
          utilities.isSelectClientRoute.set(false);
          utilities.setCompanyStatus(selected.status);
        }

        return true;
      }),
      catchError(() => {
        router.navigate(['select-client']);
        return of(false);
      })
    );
}

export const clientIdGuard: CanActivateFn = (route) => checkClientId(route);
export const clientIdChildGuard: CanActivateChildFn = (route) => checkClientId(route);
